<template>
    <div
        v-for="tag in resource.tags"
        class="
            text-md
            p-2
            rounded-full
            inline-flex
            items-center
            w-auto
            gap-2
            cursor-pointer
            opacity-100
            hover:opacity-75
        "
        :style="{
            background: tag.color,
            color: isDark(tag.color) ? '#fff' : '#000',
        }"
    >
        <img
            v-if="tag.icon_type === 'upload'"
            :src="tag.icon"
            alt=""
            class="w-[15px] h-[15px]"
        />
        <div v-if="tag.icon_type === 'emoji'">{{ tag.icon }}</div>
        <ion-icon
            v-if="tag.icon_type === 'ionicons'"
            :name="tag.icon"
        ></ion-icon>
        <span>{{ tag.name }}</span>
    </div>
</template>

<script setup>
import { isDark } from "./forms/utils";
import { onMounted, ref } from "vue";
const props = defineProps({
    resource: {
        type: Object,
        required: true,
        default: {},
    },
});
onMounted(() => {
    console.log({ rs: props.resource });
});
</script>
